<template>
  <div>
    <div>
      <v-img
        src="../assets/banner.jpg" height="550px"></v-img>
    </div>
    <div class="content-wrapper" v-if="news">
      <h2 class="d-flex justify-center align-center mt-6 mb-10">
        {{ news.title }}
      </h2>

      <div class="d-flex justify-space-around mt-6 mb-10">
        <span>发布时间：{{ news.time_publish | timeFilter}}</span>
        <span>访问量：{{ news.pvs }}</span>
      </div>
      <div v-html="news.content"></div>
    </div>
  </div>
</template>

<script>
import { getNews, getNotice } from '../api/News';

export default {
  props: {
    id: {
      type: [Number, String],
    },
  },

  data() {
    return {
      news: null,
    };
  },

  filters: {
    timeFilter(timestamp) {
      return new Date(timestamp * 1000).toLocaleString();
    },
  },
  async beforeMount() {
    const { $route } = this;
    if ($route.query.type === 'news') {
      const { data: { data: news } } = await getNews(this.id);
      this.news = news;
    } else {
      const { data: { data: notice } } = await getNotice(this.id);
      this.news = notice;
    }
  },
};
</script>

<style lang="less">
  .content-wrapper {
    width: 1200px;
    margin: 0 auto;
  }
</style>
